<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>약관관리 등록 기본정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
              <tbody class="">


              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">제목</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="7">
                      <b-form-input id="basicText" name="subject" type="text" v-model="queryParams.subject" v-validate="'required'" :class="{'is-invalid': errors.has('subject')}"></b-form-input>
                      <span v-show="errors.has('subject')" :class="{error: errors.has('subject')}">제목명은 필수 항목 입니다.</span>
                    </b-col>
                  </b-row>
                </td>
              </tr>


              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0" v-show="formtype=='insert'">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">약관타입</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="7">
                      <b-form-select
                        v-model="queryParams.term_type"
                        :value="1"
                        :options="{ 'terms': '이용약관', 'privacy': '개인정보보호정책', 'copyright': '저작권 보호방침'}"
                        id="inline-form-custom-select-pref1"
                      >
                      </b-form-select>
                    </b-col>
                  </b-row>
                </td>
              </tr>


              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">내용</label>
                </td>
                <td class="" colspan="4">
                  <vue-ckeditor v-model="queryParams.contents" :config="config" />
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="saveTerms()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/site/termsmanagement'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import swal from 'sweetalert2'
import VueCkeditor from 'vue-ckeditor2';

export default {
  components: {
    VueCkeditor
  },
  data() {
    return {
      newslettercode: '',
      newFlag:'new',
      formtype: '',
      queryParams: {
        term_type: 'terms'
      },
      enabled: true,
      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
    }
  },
  watch: {
  },
  mounted: function() {
    var self = this;
    self.formtype = self.$route.query.status;
    self.term_id = self.$session.get('term_id');


    if(self.formtype == 'update'){
      self.getDrTermsData(self.term_id);
    }

  },
  methods: {


    getDrTermsData(term_id) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/termsData?access_token=' + token + '&term_id=' + term_id)
        .then((result) => {
          self.queryParams = result.data;

        })
    },

    saveTerms() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(!self.queryParams.contents){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return;
          }

          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('termObj', param);

          console.log(self.queryParams);

          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/termData?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '약관관리가 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 2500
                }).then(function() {
                  window.location = "#/site/termsmanagement";
                });
              })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/termData?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '약관관리를 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 2500
                }).then(function() {
                  window.location = "#/site/termsmanagement";
                });
              })
          }
        }
      })
    },
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
  padding:20px
}

.normal {
  background-color: grey;
}

.dragArea{
  min-height: 10px;
}

.sortable-chosen {
  opacity: 0.7;
  background-color:#dcdcdc;
}

.sortable-ghost {
  background-color:#dcdcdc;
}
.handle {
  padding: 5px;
  margin-right: 10px;
  border: solid #000 1px;
  cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/site/terms/component/TermsForm.vue